import { MenuItemWithToggle } from 'tradera/components/site-header/menu-item-toggle';
import FashionIcon from '@tradera/blueprint/theme/icons2/fashion.svg?jsx';
import {
    useGetHomepageThemeQuery,
    useUpdateHomepageThemeMutation,
} from 'tradera/state/services/start-page-theme-api';
import { HomepageTheme } from 'tradera/state/services/types/webapi-member-generated';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { isOnStartPage } from 'tradera/components/profile-menu/helpers';
import { useNavigation } from 'tradera/hooks/use-navigation';
import { closeProfileMenu } from 'tradera/state/ui/reducer';
import { useAppDispatch, useAppSelector } from 'tradera/state/hooks';
import { ENTERED_FASHION_PAGE } from 'tradera/constants/cookies';
import { useCookieUtil } from 'tradera/hooks/use-cookie-util';
import { selectIsLoggedIn } from 'tradera/state/member/selectors';

export const FashionToggleMenuItem = () => {
    const { t } = useTranslator();
    const dispatch = useAppDispatch();
    const isLoggedIn = useAppSelector(selectIsLoggedIn);
    const { data } = useGetHomepageThemeQuery(undefined, {
        skip: !isLoggedIn,
    });
    const [updateHomepageTheme] = useUpdateHomepageThemeMutation();
    const { push } = useNavigation();
    const { toLocalizedUrl } = useUrlLocalizer();
    const cookieUtil = useCookieUtil();
    const isFashionToggleOn = data?.theme === HomepageTheme.Fashion;

    const handleFashionToggleChange = async (shouldBeToggledOn: boolean) => {
        const newTheme = shouldBeToggledOn
            ? HomepageTheme.Fashion
            : HomepageTheme.Default;

        try {
            await updateHomepageTheme({ theme: newTheme }).unwrap();
            // if actively toggling fashion theme off, store value in cookie so that navigating
            // to /fashion in the future doesn't activate the fashion theme again
            if (!shouldBeToggledOn) {
                cookieUtil.createCookie(ENTERED_FASHION_PAGE, true, 365);
            }
            if (isOnStartPage(window.location.pathname)) {
                push(toLocalizedUrl(shouldBeToggledOn ? '/fashion' : '/'));
                dispatch(closeProfileMenu());
            }
        } catch (error) {
            console.error('Failed to update theme', error);
        }
    };

    return (
        <MenuItemWithToggle
            id="fashion-toggle"
            label={t('siteheader_fashion_startpage')}
            icon={<FashionIcon className="icon-md" />}
            checked={isFashionToggleOn}
            onChange={() => handleFashionToggleChange(!isFashionToggleOn)}
            border
        />
    );
};
